/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type LocalityTypeEnum = (typeof LocalityTypeEnum)[keyof typeof LocalityTypeEnum];

export const LocalityTypeEnum = {
  city: 'city',
  neighborhood: 'neighborhood',
} as const;
